<div [formGroup]="form" class="role-item-form gap-3">
  <app-form-role-input
    #roleInput
    formControlName="role"
    [isEditable]="isRoleEditable"
    [isDuplicated]="form.get('role').hasError('duplicated')"
    (roleSelect)="onRoleSelect($event)"
  ></app-form-role-input>
  <div>
    <div class="toggle-btns-wrapper text-xxl">
      <span
        class="toggle-btn"
        i18n-matTooltip
        matTooltip="Mark National ID as Required"
        [class.active]="isIdPhotoRequired"
        (click)="toggleIdPhoto()"
      >
        <i class="cs-icon" [ngClass]="isIdPhotoRequired ? 'cs-icon-id-card-solid' : 'cs-icon-id-card'"></i>
      </span>
      <span
        class="toggle-btn selfie-icon"
        i18n-matTooltip
        matTooltip="Mark Selfie as Required"
        [class.active]="isSelfiePhotoRequired"
        (click)="toggleSelfiePhoto()"
      >
        <i class="cs-icon" [ngClass]="isSelfiePhotoRequired ? 'cs-icon-selfie-solid' : 'cs-icon-selfie'"></i>
      </span>
    </div>
    <div class="toggle-btns-description" [class.active]="isIdPhotoRequired || isSelfiePhotoRequired">
      {{ getPhotosRequirementDescription() }}
    </div>
  </div>

  <a
    href="javascript:;"
    *ngIf="removable && isRoleEditable"
    i18n-matTooltip
    matTooltip="Click here to remove this signer"
    class="btn btn-sm btn-light-danger ml-auto"
    (click)="onRemove()"
  >
    <i class="cs-icon cs-icon-trash text-xl"></i>
  </a>
</div>
